export default function Section4() {
    return (
        <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20">
            <h1 className="text-black text-center text-[32px] md:text-[42px] font-bold mb-10 leading-[32px] md:leading-[41px]">
                Search Engine Optimization Services
            </h1>
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">

                {/* Left Side - Text */}
                <div className="md:w-1/2 text-center md:text-left mt-10">

                    <h1 className="text-[24px] md:text-[32px] font-bold text-[#1a1a1a] mb-6 leading-[32px] md:leading-[41px]">
                        Search Engine Optimization Services That Drive Revenue, Not Just Rankings
                    </h1>
                    <p className="text-gray-600 mb-8">
                        Increase qualified organic traffic, improve search visibility, and turn search engines into a consistent revenue channel with Mean3’s SEO services.
                    </p>
                    <p className="text-gray-600 mb-8">We provide search engine optimization services designed to help businesses rank for high-intent keywords, outperform competitors, and generate measurable growth in traffic, leads, and revenue.</p>
                    <p className="text-gray-600 mb-8">We do not just “do SEO.” As a professional SEO agency, we build search systems that help your business win in competitive search results.</p>

                    {/* CTA Buttons */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-10">
                        {/* <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Get Your Free SEO Audit
                        </a> */}
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
                        >
                            Schedule a Strategy Call
                        </a>
                    </div>
                </div>

                {/* Right Side - Hero Image */}
                <div className="md:w-1/2 flex justify-center">
                    <img
                        src="/assets/seo-hero.png" // Replace with your hero image path
                        alt="SEO Hero Illustration"
                        className="w-[90%] md:w-[100%] h-auto rounded-lg shadow-lg"
                    />
                </div>
            </div>

            {/* Problem Statement + Issues List */}
            <div className="max-w-6xl mx-auto mt-20 flex flex-col md:flex-row-reverse items-center gap-12">
                {/* Right Side - Existing SEO image */}
                <div className="md:w-1/2">
                    <img
                        src="/assets/SEO.jpg"
                        alt="SEO Problem Illustration"
                        className="w-full h-auto rounded-lg shadow-lg"
                    />
                </div>

                {/* Left Side - Content */}
                <div className="md:w-1/2 text-center md:text-left">
                    <h3 className="text-2xl font-bold text-[#151515] mb-6">
                        Is Your Website Invisible Online?
                    </h3>
                    <p className="text-gray-600 mb-8">
                        Many businesses struggle with low traffic, weak leads, and poor search visibility. Without
                        SEO, your competitors may get all the customers, even if your products or services are
                        better. Common issues include:
                    </p>

                    {/* Issues List */}
                    <ul className="space-y-5 mb-8">
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Your website is not showing in Google searches</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Pages are slow or hard to navigate</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Keywords are missing or not targeted correctly</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Your content does not attract or engage visitors</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Local customers cannot find your business online</p>
                        </li>
                        <li className="flex items-start gap-4">
                            <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                                ✓
                            </div>
                            <p className="text-gray-800 font-medium">Ecommerce stores do not rank for important products</p>
                        </li>
                    </ul>

                    {/* Inline CTA */}
                    <div className="mt-10">
                        <a
                            href="https://mean3.com/contact-mean3/"
                            className="inline-block bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
                        >
                            Schedule a Call With Us
                        </a>
                    </div>
                </div>
            </div>
            <div className="max-w-6xl mx-auto mt-20 flex flex-col md:flex-row-reverse items-center gap-12">
    {/* Right Side - Existing SEO image */}
    <div className="md:w-1/2">
        <img
            src="/assets/SEO.jpg"
            alt="SEO Problem Illustration"
            className="w-full h-auto rounded-lg shadow-lg"
        />
    </div>

    {/* Left Side - Content */}
    <div className="md:w-1/2 text-center md:text-left">
        <h2 className="text-2xl font-bold text-[#151515] mb-6">
            Why Your Website Is Losing Organic Traffic
        </h2>

        <p className="text-gray-600 mb-6">
            Most websites do not fail because of bad products or services. They fail because they are not visible
            in search engines.
        </p>

        <p className="text-gray-600 mb-8">
            If your SEO is not working, it usually comes down to structural and content issues like:
        </p>

        {/* Issues List */}
        <ul className="space-y-5 mb-8">
            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Your competitors consistently outrank you for high-value keywords
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Your website gets traffic but few conversions or leads
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Important service or product pages are not indexed properly
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    You rely heavily on paid ads instead of organic search
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Technical SEO issues affect crawlability and rankings
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Local customers cannot find your business in search results
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Your content does not match search intent or user needs
                </p>
            </li>
        </ul>

        <p className="text-gray-600">
            When these issues exist, your website is not being penalized. It is simply not optimized for how
            search engines evaluate relevance and authority.
        </p>

        {/* Inline CTA */}
        <div className="mt-10">
            <a
                href="https://mean3.com/contact-mean3/"
                className="inline-block bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
            >
                Schedule a Call With Us
            </a>
        </div>
    </div>
</div>
<div className="max-w-6xl mx-auto mt-20 flex flex-col md:flex-row-reverse items-center gap-12">
    {/* Right Side - Existing SEO image */}
    <div className="md:w-1/2">
        <img
            src="/assets/SEO.jpg"
            alt="SEO Problem Illustration"
            className="w-full h-auto rounded-lg shadow-lg"
        />
    </div>

    {/* Left Side - Content */}
    <div className="md:w-1/2 text-center md:text-left">
        <h2 className="text-2xl font-bold text-[#151515] mb-6">
            The Real Problem Is Not Your Business, It Is Your SEO System
        </h2>

        <p className="text-gray-600 mb-6">
            If your competitors are getting more traffic, it is not because they are better. It is because their
            SEO system is stronger.
        </p>

        <p className="text-gray-600 mb-8">
            Modern search engine optimization services are not about isolated fixes like keywords or backlinks.
            It is a connected system that includes:
        </p>

        {/* Issues List */}
        <ul className="space-y-5 mb-8">
            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Technical structure that ensures full crawlability and indexation
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Content optimized around search intent and user behavior
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Authority signals that build trust in your domain
                </p>
            </li>

            <li className="flex items-start gap-4">
                <div className="flex-shrink-0 w-6 h-6 bg-[#DA2128] text-white rounded-full flex items-center justify-center mt-1">
                    ✓
                </div>
                <p className="text-gray-800 font-medium">
                    Internal linking that distributes ranking power across pages
                </p>
            </li>
        </ul>

        <p className="text-gray-600">
            Without these working together, rankings stay inconsistent and unpredictable.
        </p>

        {/* Inline CTA */}
        <div className="mt-10">
            <a
                href="https://mean3.com/contact-mean3/"
                className="inline-block bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
            >
                Schedule a Call With Us
            </a>
        </div>
    </div>
</div>
        </section>
    );
}
